import React, { Component } from "react";
import { connect } from "react-redux";
import FontAwesome from "react-fontawesome";
import moment from "moment";
import numeral from "numeral";

import ButtonStrip from "../../Layout/components/ButtonStrip";
import BoxButton from "../../Layout/components/BoxButton";
import Input from '@mawesi-sas/mws_react_component_input';

import {
  adicionarDetalle,
  eliminarDetalles,
  almacenarDetalles,
  marcarComoActualizado,
  toggleSelectAllItems
} from "../actions";

import { showModalConfirmAction } from "../../Layout/actions";
import Box from "../../Layout/components/Box";

export function findValues(c, x) {
  let value = x.get(String(c.get("id")));
  return value;
}

class DetalleParametro extends Component {
  render() {
    const { selected, parametro, saving } = this.props;
    if (!selected) {
      return (
        <div
          style={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <p
            style={{
              fontSize: "1.5em",
              color: "rgb(187,187,187)",
              fontStyle: "italic",
              fontWeight: "100"
            }}
          >
            <FontAwesome name="info-circle" /> Seleccione un parametro para
            visualizar/modificar su detalle
          </p>
        </div>
      );
    }

    const eliminarDisabled =
      parametro
        .get("data")
        .filter(x => x.get("selected"))
        .count() === 0;
    const buttons = [];
    if (this.props.elementos.filter(x => x === "seP1L9u9").count())
      buttons.push(
        <BoxButton
          key={`action[1][0]`}
          name="floppy-o"
          title="Guardar"
          onClick={() => this.props.almacenarDetalles()}
          disabled={saving}
        />
      );
    if (this.props.elementos.filter(x => x === "seP1L9u9").count())
      buttons.push(
        <BoxButton
          key={`action[1][1]`}
          name="plus"
          title="Nuevo registro"
          onClick={() => this.props.adicionarDetalle()}
        />
      );
    if (this.props.elementos.filter(x => x === "uuNsJgIx").count())
      buttons.push(
        <BoxButton
          key={`action[1][2]`}
          name="trash"
          title="Eliminar registro"
          onClick={() =>
            this.props.showModalConfirmAction(
              true,
              "Está seguro que desea eliminar los registros seleccionados?",
              () => this.props.eliminarDetalles()
            )
          }
          disabled={eliminarDisabled}
          danger
        />
      );

    const tableColumns = parametro
      .getIn(["configuraciones"])
      .valueSeq()
      .sortBy(x => x.get("order_key"))
      .map(x => {
        return {
          id: x.get("id"),
          campo: x.get("campo"),
          caption: x.get("nombre"),
          value: `campo${x.get("campo")}`
        };
      })
      .toJS();

    return (
      <Box title="Detalles parámetro:" stretch>
        <ButtonStrip actions={buttons} />
        <div className="box-content" style={{ flex: 1, height: 0 }}>
          <table className="table table-condensed table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th width="25px">
                  <input
                    type="checkbox"
                    style={{ verticalAlign: "middle" }}
                    onChange={e =>
                      this.props.toggleSelectAllItems(e.target.checked)
                    }
                    checked={
                      parametro
                        .get("data")
                        .valueSeq()
                        .filter(x => x.get("selected"))
                        .count() > 0 &&
                      parametro
                        .get("data")
                        .valueSeq()
                        .filter(x => x.get("selected"))
                        .count() >=
                        parametro
                          .get("data")
                          .valueSeq()
                          .count()
                    }
                  />
                </th>
                {parametro.get("columnas").map(p => {
                  return (
                    <th key={`th4[${p.get("id")}]`}>{p.get("caption")}</th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {parametro.get("data").count() > 0 ? (
                parametro
                  .get("data")
                  .keySeq()
                  .sortBy(x => Number(x))
                  .map(n => {
                    const p = parametro.getIn(["data", n]);
                    return (
                      <tr
                        key={`tr4[${p.get("registro")}]`}
                        className={p.get("selected") ? "info" : ""}
                      >
                        <td style={{ lineHeight: "23px" }}>
                          <Input
                            type="checkbox"
                            reducer="parameters"
                            path={`parametros.${selected}.data.${n}.selected`}
                            className="form-control input-sm"
                          />
                        </td>
                        {parametro.get("columnas").map(c => {
                          const foundVal = findValues(c, p);
                          let value = foundVal.get("valor");
                          let path = `parametros.${selected}.data.${n}.${c.get(
                            "id"
                          )}`;
                          if (c.get("type")) {
                            switch (c.get("type")) {
                              case "datetime":
                                value = moment(value).format(c.get("format"));
                                break;
                              case "bool":
                                value = value = (
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontSize: "1.1em"
                                    }}
                                  >
                                    <i
                                      className={`fa fa-${
                                        value ? "check-" : ""
                                      }square`}
                                    />
                                  </div>
                                );
                                break;
                              case "number":
                                value = numeral(value).format(c.get("format"));
                                break;
                              default:
                            }
                          }

                          return (
                            <td key={`td4[${foundVal.get("guid")}]`}>
                              <Input
                                type="text"
                                reducer="parameters"
                                path={`${path}.valor`}
                                className="form-control input-sm"
                                afterChange={() =>
                                  this.props.marcarComoActualizado(path)
                                }
                              />
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })
              ) : (
                <tr>
                  <td colSpan={parametro.get("columnas").count() + 1}>
                    No existen registros
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state, onwProps) => {
  return {
    selected: state.parameters.get("selected"),
    parametro: state.parameters.getIn([
      "parametros",
      String(state.parameters.get("selected"))
    ]),
    saving: state.parameters.get("saving"),
    elementos: state.layout.get("elementos")
  };
};

const mapDispatchToProps = dispatch => {
  return {
    adicionarDetalle: () => dispatch(adicionarDetalle()),
    eliminarDetalles: () => dispatch(eliminarDetalles()),
    almacenarDetalles: () => dispatch(almacenarDetalles()),
    marcarComoActualizado: path => dispatch(marcarComoActualizado(path)),
    showModalConfirmAction: (show, message, action) =>
      dispatch(showModalConfirmAction(show, message, action)),
    toggleSelectAllItems: checked => dispatch(toggleSelectAllItems(checked))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DetalleParametro);
